import { FC } from 'react';
import { withStyles, SwitchIndicator } from 'vopay';

import styles from './Toggle.module.scss';

const cn = withStyles(styles);

type ToggleProps = {
  name: string;
  checked: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
};

const Toggle: FC<ToggleProps> = ({ name, checked, onChange }) => (
  <label htmlFor={`checkbox-${name}`}>
    <SwitchIndicator checked={checked} />
    <input
      className={cn('hiddenCheckbox')}
      id={`checkbox-${name}`}
      type="checkbox"
      name={name}
      checked={checked}
      onChange={onChange}
    />
  </label>
);

export default Toggle;
